// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_postcss@8.5.15_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_postcss@8.5.15_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auth-page {
    width: min(1120px, calc(100% - 64px));
    min-height: calc(100dvh - 72px);
    margin: 0 auto;
    padding: clamp(44px, 5vw, 72px) 0 112px;
    display: grid;
    grid-template-columns: minmax(0, 1.1fr) minmax(360px, .9fr);
    gap: clamp(56px, 9vw, 130px);
    align-items: start;
    background: var(--tp-bg);
    color: var(--tp-text);
}

.auth-intro {
    padding-top: 8px;
    border-top: 3px solid var(--tp-ink);
}

.login-label,
.signup-label {
    margin: 0 0 clamp(34px, 6vw, 72px);
    color: var(--tp-signal);
    font-size: 11px;
    font-weight: 850;
    letter-spacing: .14em;
}

.login-title,
.signup-title {
    max-width: 12ch;
    margin: 0 0 24px;
    color: var(--tp-ink);
    font-size: var(--tp-title-page);
    font-weight: 850;
    line-height: 1.1;
    letter-spacing: -.045em;
    word-break: keep-all;
}

.auth-intro > p:last-child {
    max-width: 42ch;
    margin: 0;
    color: var(--tp-muted);
    font-size: 15px;
    line-height: 1.7;
}

.auth-form {
    padding: 28px;
    border: 1px solid var(--tp-rule);
    border-radius: var(--tp-radius-surface);
    background: var(--tp-sheet);
}

.auth-field + .auth-field { margin-top: 24px; }

.auth-field label {
    display: block;
    margin-bottom: 8px;
    color: var(--tp-ink);
    font-size: 12px;
    font-weight: 800;
}

.auth-field input {
    width: 100%;
    min-height: 52px;
    padding: 0 4px;
    border: 0;
    border-bottom: 1px solid var(--tp-rule);
    border-radius: 0;
    outline: 0;
    background: transparent;
    color: var(--tp-ink);
    font-size: 16px;
}

.auth-field input:focus { border-bottom-color: var(--tp-ink); }

.login-button,
.signup-button {
    width: 100%;
    min-height: 52px;
    margin-top: 30px;
    border: 1px solid var(--tp-ink);
    border-radius: var(--tp-radius-control);
    background: var(--tp-ink);
    color: var(--tp-sheet);
    font-size: 14px;
    font-weight: 850;
    cursor: pointer;
}

.login-button:disabled,
.signup-button:disabled { opacity: .55; cursor: wait; }

.login-error,
.signup-error {
    margin: 22px 0 -8px;
    padding: 12px 14px;
    border-left: 3px solid var(--tp-error);
    background: color-mix(in srgb, var(--tp-error) 8%, var(--tp-surface));
    color: var(--tp-error);
    font-size: 12px;
    font-weight: 700;
    line-height: 1.55;
}

.signup-text-wrap,
.signup-login-link {
    margin: 22px 0 0;
    color: var(--tp-muted);
    font-size: 12px;
    text-align: center;
}

.signup-text-button,
.signup-login-link a {
    margin-left: 6px;
    color: var(--tp-ink);
    font-weight: 850;
    text-underline-offset: 3px;
}

@media (max-width: 767px) {
    .auth-page {
        width: calc(100% - 36px);
        min-height: calc(100dvh - 64px);
        padding: 34px 0 116px;
        display: block;
    }

    .auth-intro { margin-bottom: 38px; }
    .login-label, .signup-label { margin-bottom: 30px; }

    .login-title,
    .signup-title {
        max-width: 12ch;
        font-size: var(--tp-title-page-mobile);
    }

    .auth-form { padding: 24px 20px; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/AuthPage.css"],"names":[],"mappings":"AAAA;IACI,qCAAqC;IACrC,+BAA+B;IAC/B,cAAc;IACd,uCAAuC;IACvC,aAAa;IACb,2DAA2D;IAC3D,4BAA4B;IAC5B,kBAAkB;IAClB,wBAAwB;IACxB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,mCAAmC;AACvC;;AAEA;;IAEI,kCAAkC;IAClC,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;;IAEI,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,+BAA+B;IAC/B,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,SAAS;IACT,sBAAsB;IACtB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,uCAAuC;IACvC,2BAA2B;AAC/B;;AAEA,4BAA4B,gBAAgB,EAAE;;AAE9C;IACI,cAAc;IACd,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,SAAS;IACT,uCAAuC;IACvC,gBAAgB;IAChB,UAAU;IACV,uBAAuB;IACvB,oBAAoB;IACpB,eAAe;AACnB;;AAEA,0BAA0B,kCAAkC,EAAE;;AAE9D;;IAEI,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,+BAA+B;IAC/B,uCAAuC;IACvC,yBAAyB;IACzB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;0BAC0B,YAAY,EAAE,YAAY,EAAE;;AAEtD;;IAEI,mBAAmB;IACnB,kBAAkB;IAClB,sCAAsC;IACtC,qEAAqE;IACrE,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;;IAEI,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;IACf,kBAAkB;AACtB;;AAEA;;IAEI,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI;QACI,wBAAwB;QACxB,+BAA+B;QAC/B,qBAAqB;QACrB,cAAc;IAClB;;IAEA,cAAc,mBAAmB,EAAE;IACnC,8BAA8B,mBAAmB,EAAE;;IAEnD;;QAEI,eAAe;QACf,sCAAsC;IAC1C;;IAEA,aAAa,kBAAkB,EAAE;AACrC","sourcesContent":[".auth-page {\n    width: min(1120px, calc(100% - 64px));\n    min-height: calc(100dvh - 72px);\n    margin: 0 auto;\n    padding: clamp(44px, 5vw, 72px) 0 112px;\n    display: grid;\n    grid-template-columns: minmax(0, 1.1fr) minmax(360px, .9fr);\n    gap: clamp(56px, 9vw, 130px);\n    align-items: start;\n    background: var(--tp-bg);\n    color: var(--tp-text);\n}\n\n.auth-intro {\n    padding-top: 8px;\n    border-top: 3px solid var(--tp-ink);\n}\n\n.login-label,\n.signup-label {\n    margin: 0 0 clamp(34px, 6vw, 72px);\n    color: var(--tp-signal);\n    font-size: 11px;\n    font-weight: 850;\n    letter-spacing: .14em;\n}\n\n.login-title,\n.signup-title {\n    max-width: 12ch;\n    margin: 0 0 24px;\n    color: var(--tp-ink);\n    font-size: var(--tp-title-page);\n    font-weight: 850;\n    line-height: 1.1;\n    letter-spacing: -.045em;\n    word-break: keep-all;\n}\n\n.auth-intro > p:last-child {\n    max-width: 42ch;\n    margin: 0;\n    color: var(--tp-muted);\n    font-size: 15px;\n    line-height: 1.7;\n}\n\n.auth-form {\n    padding: 28px;\n    border: 1px solid var(--tp-rule);\n    border-radius: var(--tp-radius-surface);\n    background: var(--tp-sheet);\n}\n\n.auth-field + .auth-field { margin-top: 24px; }\n\n.auth-field label {\n    display: block;\n    margin-bottom: 8px;\n    color: var(--tp-ink);\n    font-size: 12px;\n    font-weight: 800;\n}\n\n.auth-field input {\n    width: 100%;\n    min-height: 52px;\n    padding: 0 4px;\n    border: 0;\n    border-bottom: 1px solid var(--tp-rule);\n    border-radius: 0;\n    outline: 0;\n    background: transparent;\n    color: var(--tp-ink);\n    font-size: 16px;\n}\n\n.auth-field input:focus { border-bottom-color: var(--tp-ink); }\n\n.login-button,\n.signup-button {\n    width: 100%;\n    min-height: 52px;\n    margin-top: 30px;\n    border: 1px solid var(--tp-ink);\n    border-radius: var(--tp-radius-control);\n    background: var(--tp-ink);\n    color: var(--tp-sheet);\n    font-size: 14px;\n    font-weight: 850;\n    cursor: pointer;\n}\n\n.login-button:disabled,\n.signup-button:disabled { opacity: .55; cursor: wait; }\n\n.login-error,\n.signup-error {\n    margin: 22px 0 -8px;\n    padding: 12px 14px;\n    border-left: 3px solid var(--tp-error);\n    background: color-mix(in srgb, var(--tp-error) 8%, var(--tp-surface));\n    color: var(--tp-error);\n    font-size: 12px;\n    font-weight: 700;\n    line-height: 1.55;\n}\n\n.signup-text-wrap,\n.signup-login-link {\n    margin: 22px 0 0;\n    color: var(--tp-muted);\n    font-size: 12px;\n    text-align: center;\n}\n\n.signup-text-button,\n.signup-login-link a {\n    margin-left: 6px;\n    color: var(--tp-ink);\n    font-weight: 850;\n    text-underline-offset: 3px;\n}\n\n@media (max-width: 767px) {\n    .auth-page {\n        width: calc(100% - 36px);\n        min-height: calc(100dvh - 64px);\n        padding: 34px 0 116px;\n        display: block;\n    }\n\n    .auth-intro { margin-bottom: 38px; }\n    .login-label, .signup-label { margin-bottom: 30px; }\n\n    .login-title,\n    .signup-title {\n        max-width: 12ch;\n        font-size: var(--tp-title-page-mobile);\n    }\n\n    .auth-form { padding: 24px 20px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
